import config from '@config';

import api from 'api';

/**
 * Functions de l'API REST ACF
 */
export default {
	/**
	 * Récupère la valeur d'un champ acf d'une page d'options ACF Pro
	 *
	 * @param {String} name
	 *
	 * @param {String} page
	 *    Le nom de la page d'options
	 */
	getOptionField(name, page = 'Options') {
		return new api.WPRequest(config.acf_api_path)
			.get('options/:page/:name')
			.assert(page != null, new TypeError('La page indiqué est nulle'))
			.assert(name != null, new TypeError('Le nom indiqué est nul'))
			.bind('page', page)
			.bind('name', name)
			.execute();
	},

	/**
	 * Récupère tous les champs acf liés à une page d'options ACF Pro
	 *
	 * @param {String} page
	 *    Le nom de la page d'options
	 */
	getOptionFields(page = 'Options') {
		return new api.WPRequest(config.acf_api_path)
			.get('options/:page')
			.assert(page != null, new TypeError('La page indiqué est nulle'))
			.bind('page', page)
			.execute();
	},

	/**
	 * (Fonction ACF générique adaptable à tous types de contenus : posts, pages, taxonomies, post-types, etc...)
	 * Récupère la valeur d'un champ acf d'un type de contenu à partir d'un id du contenu et d'un nom de champ
	 *
	 * @param {String} name
	 *
	 * @param {String} content
	 *    Le type de contenu à cibler
	 * @param {Number} id
	 */
	getField(name, content, id) {
		return new api.WPRequest(config.acf_api_path)
			.get(':content/:id/:name')
			.assert(content != null, new TypeError('Le type de contenu indiqué est nul'))
			.assert(id != null, new TypeError("L'id indiqué est nul"))
			.assert(!isNaN(id), new TypeError("L'id indiqué n'est pas un nombre valide"))
			.assert(name != null, new TypeError('Le nom indiqué est nul'))
			.bind('content', content)
			.bind('id', id)
			.bind('name', name)
			.execute();
	},

	/**
	 * (Fonction ACF générique adaptable à tous types de contenus : posts, pages, taxonomies, post-types, etc...)
	 * Récupère la valeur des champs acf associés à un post
	 * Si l'id du post n'est pas précisé, les champs de tous les posts sont retournées
	 *
	 * @param {String} content
	 *    Le type de contenu à cibler
	 * @param {Number} id
	 */
	getFields(content, id) {
		return new api.WPRequest(config.acf_api_path)
			.get(':content/:id')
			.assert(content != null, new TypeError('Le type de contenu indiqué est nul'))
			.bind('content', content)
			.ifbind(id !== undefined, 'id', id)
			.execute();
	},
};



// WEBPACK FOOTER //
// ./src/api/acf.js